module.exports = "/_next/static/images/bni-icon-469c06fb1544961bc95cae58702e830b.svg";